import validateContact from './contact';
import validateSummary from './summary';
import validateExperience from './experience';
import validateProjects from './projects';
import validateSkills from './skills';
import validateEducation from './education';
import { getRegistryItem } from '../registry';

const LEGACY_VALIDATORS = {
  contact: validateContact,
  summary: validateSummary,
  experience: validateExperience,
  projects: validateProjects,
  skills: validateSkills,
  education: validateEducation
};

export function validateSection(sectionId, data) {
  // Use legacy validator if available for backward compatibility
  if (LEGACY_VALIDATORS[sectionId]) {
    return LEGACY_VALIDATORS[sectionId](data);
  }

  const meta = getRegistryItem(sectionId);
  if (!meta) {
    return { completed: true, percentage: 100, errors: [], warnings: [] };
  }

  const errors = [];
  const warnings = [];

  // 1. Array-based sections (allowMultiple: true)
  if (meta.allowMultiple) {
    const list = Array.isArray(data) ? data : [];
    if (list.length === 0) {
      if (meta.required) {
        errors.push(`At least one ${meta.title} entry is required.`);
        return { completed: false, percentage: 0, errors, warnings };
      }
      return { completed: true, percentage: 100, errors, warnings };
    }

    let totalFieldsChecked = 0;
    let filledFieldsCount = 0;

    list.forEach((item, idx) => {
      meta.fields?.forEach(field => {
        totalFieldsChecked++;
        const val = item[field.name];
        const isFilled = val !== undefined && val !== null && String(val).trim().length > 0;
        
        if (isFilled) {
          filledFieldsCount++;
        }

        if (field.required && !isFilled) {
          errors.push(`Item #${idx + 1}: "${field.label}" is required.`);
        }

        // Format checks
        if (isFilled) {
          if (field.type === 'email' && !/\S+@\S+\.\S+/.test(val)) {
            warnings.push(`Item #${idx + 1}: "${field.label}" format is invalid.`);
          }
          if (field.type === 'url' && !/^https?:\/\/\S+/.test(val)) {
            warnings.push(`Item #${idx + 1}: "${field.label}" should be a valid URL.`);
          }
        }
      });
    });

    const percentage = totalFieldsChecked > 0 ? Math.round((filledFieldsCount / totalFieldsChecked) * 100) : 100;
    return {
      completed: errors.length === 0,
      percentage,
      errors,
      warnings
    };
  }

  // 2. Flat object-based sections (allowMultiple: false)
  const obj = data || {};
  let totalFieldsChecked = 0;
  let filledFieldsCount = 0;

  meta.fields?.forEach(field => {
    totalFieldsChecked++;
    const val = obj[field.name];
    const isFilled = val !== undefined && val !== null && String(val).trim().length > 0;

    if (isFilled) {
      filledFieldsCount++;
    }

    if (field.required && !isFilled) {
      errors.push(`"${field.label}" is required.`);
    }

    if (isFilled) {
      if (field.type === 'email' && !/\S+@\S+\.\S+/.test(val)) {
        warnings.push(`"${field.label}" format is invalid.`);
      }
      if (field.type === 'url' && !/^https?:\/\/\S+/.test(val)) {
        warnings.push(`"${field.label}" should be a valid URL.`);
      }
    }
  });

  const percentage = totalFieldsChecked > 0 ? Math.round((filledFieldsCount / totalFieldsChecked) * 100) : 100;
  return {
    completed: errors.length === 0,
    percentage,
    errors,
    warnings
  };
}
